// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__2XymJ","pinned":"List_pinned__RBqE3","item":"List_item__RbAhw"};